var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"clearable":"","label":_vm.placeholder,"placeholder":"Placeholder","prepend-icon":"mdi-magnify"},on:{"input":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }